import styled from 'styled-components';

import { media, space } from '../../ui/helpers';

const Module = styled.div`
  background: ${({ theme }) => theme.background};
  padding-top: ${space(6)};
  padding-bottom: ${space(6)};
  width: 100%;

  ${media.min('medium')`
    padding-top: ${space(8)};
    padding-bottom: ${space(8)};
  `}
`;

const Container = styled.div`
  display: flex;
  justify-content: center;
`;

export { Module, Container };
